import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'luxonUtcFromNow' })
export class LuxonUtcFromNowPipe implements PipeTransform {
    transform(value: DateTime) {
        if (!value) {
            return '';
        }

        return value.toUTC().toRelative();
    }
}
